module.exports = __webpack_public_path__ + "static/media/squarespace.e0412cd6.svg";